import { createToast } from "@faire/web/slate/Toast";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { Medium } from "@faire/web/ui/Typography/Span";
import truncate from "lodash/truncate";
import * as React from "react";

interface IProps {
  brandName: string | undefined;
}

export const BrandFollowToast: React.FC<IProps> = ({ brandName }) => (
  <StrictLocalMsg
    defaultMessage="Following <MediumFormatting>{brandCompanyName}</MediumFormatting>"
    values={{
      brandCompanyName: truncate(brandName, { length: 20 }),
      MediumFormatting,
    }}
  />
);

const MediumFormatting = (chunks: JSX.Element) => <Medium>{chunks}</Medium>;

export const showBrandFollowToast = (brandName: string | undefined) => {
  createToast(<BrandFollowToast brandName={brandName} />, {
    timeout: "short",
  });
};
